import { fromSpecific } from '@rehaje/core'
import { reactive } from '@rehaje/reactive'

import { ValuableNode } from '../../models'

import type { SchemaNode } from '../../models'

export class SchemaFunctionNode extends ValuableNode {
  @fromSpecific()
  @reactive('shallow')
  additionalParameters?: SchemaNode

  @fromSpecific()
  @reactive()
  async: boolean = false

  @fromSpecific()
  @reactive()
  generator: boolean = false

  @fromSpecific()
  @reactive('shallow')
  parameters: SchemaNode[] = []

  @fromSpecific()
  @reactive()
  return?: SchemaNode
}

declare global {
  export interface RehajeTypedNodes {
    'Schema.Function': SchemaFunctionNode
  }
}
